import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { uploadFinishedSelector } from '../../../redux/import/sliceImportFileUpload';
import { IAppReduxStore } from '../../../redux/store';
import { ToastSeverity } from '../Toast/Toast';
import { useEnqueueSnackbar } from '../../../hooks/useEnqueueSnackbar';
import { useTranslation } from 'react-i18next';

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'notifications' });
    const enqueueSnackbar = useEnqueueSnackbar();

    const uploadDialogOpen = useSelector((_store: IAppReduxStore) => _store.importDialog.open);
    const uploadDialogHidden = useSelector((_store: IAppReduxStore) => _store.importDialog.hidden);

    const uploadFinished = useSelector(uploadFinishedSelector);
    const failedUploads = useSelector(
        (_store: IAppReduxStore) => _store.projectFileUpload.failedUploads,
    );

    useEffect(() => {
        if (failedUploads.length > 0 && uploadDialogOpen && uploadDialogHidden) {
            enqueueSnackbar(`${failedUploads.slice().pop().fileName}`, {
                severity: ToastSeverity.Error,
                autoHideDuration: null,
            });
        }
    }, [failedUploads]);

    useEffect(() => {
        if (uploadFinished && uploadDialogOpen && uploadDialogHidden) {
            setTimeout(() => {
                enqueueSnackbar(
                    t('uploadComplete', {
                        succeed: uploadFinished.succeed,
                        total: uploadFinished.total,
                    }),
                    {
                        severity: uploadFinished.failed
                            ? ToastSeverity.Error
                            : ToastSeverity.Success,
                        autoHideDuration: uploadFinished.failed ? null : undefined,
                    },
                );
            }, 500);
        }
    }, [uploadFinished]);

    return <></>;
};
